import React from 'react'
import LoadingIndicator from '@/components/LoadingIndicator'
export function asyncComponent (importComponent, inline) {
  class AsyncComponent extends React.Component {
    constructor (props) {
      super(props)

      this.state = {
        component: null
      }
    }

    async componentDidMount () {
      const { default: component } = await importComponent()

      if (!this._unmounted) {
        this.setState({
          component: component
        })
      }
    }

    componentWillUnmount () {
      this._unmounted = true
    }

    render () {
      const C = this.state.component
      return C ? <C {...this.props} /> : <LoadingIndicator inline={inline} />
    }
  }
  return AsyncComponent
}



// WEBPACK FOOTER //
// ./src/components/asyncComponent.js